import React, { useEffect, useState } from 'react';
import { SecondaryBase } from '../Commons/SecondaryBase';
import { ResetCurrentDynamic as BLResetCurrentDynamic } from '../../../utilities/BL/Zones';
import { GetRankingBL, GetAllPlayersBL, EditPlayerBL, SendScreenCommandBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL } from './../../../utilities/BL/CatchTheBall';
//import { GetRankingBL, GetAllPlayersBL, EditPlayerBL, SendScreenCommandBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL } from '../../../utilities/BL/Admin/Games/CatchTheBall';
import { ConnectWebSocketForOverlay } from '../../../utilities/BL/Zones'; // Para escuchar el estatus en vivo


const CatchTheBall = ({ getOutOfTheDynamic }) => {
    // Listas y UI
    const [ranking, setRanking] = useState([]);
    const [fullList, setFullList] = useState([]);
    const [showFullList, setShowFullList] = useState(false);
    const [isWorking, setIsWorking] = useState(false);
    const [liveStatus, setLiveStatus] = useState('ESPERANDO ACCIÓN...');
    
    // Reglas Parametrizadas
    //const [rules, setRules] = useState({ duration: 60, ballsToSpawn: 5, cardInterval: 12, trophySeconds: 10 });
    const [rules, setRules] = useState({ 
        duration: 60, 
        ballsToSpawn: 5, 
        cardInterval: 12, 
        trophySeconds: 10,
        playerScale: 3, 
        itemScale: 1.5 
    });
    
    // Manual Player Form
    const [manualPlayer, setManualPlayer] = useState({ fullName: '', nickname: '', score: 0 });
    
    // Edición
    const [editingId, setEditingId] = useState(null);
    const [editNickname, setEditNickname] = useState('');

    // CARGA DE DATOS
    const loadData = async () => {
        const resRank = await GetRankingBL();
        if (resRank.success) setRanking(resRank.data);
        
        const resAll = await GetAllPlayersBL();
        if (resAll.success) setFullList(resAll.data);
    };

    useEffect(() => {
        loadData();
        const interval = setInterval(loadData, 5000);
        
        // Escucha silenciosa del WebSocket para el "Live Status"
        ConnectWebSocketForOverlay('catchtheball', () => {}, (msg) => {
            if (msg?.data?.action === 'player_ready') setLiveStatus(`🟢 JUGANDO AHORA: ${msg.data.payload.nickname.toUpperCase()}`);
            if (msg?.data?.action === 'game_over') setLiveStatus(`🔴 PARTIDA TERMINADA (${msg.data.payload.score} Puntos)`);
            if (msg?.data?.action === 'show_ranking') setLiveStatus('🏆 MOSTRANDO RANKING');
            if (msg?.data?.action === 'show_frontpage') setLiveStatus('🎬 MOSTRANDO PORTADA');
        });

        return () => clearInterval(interval);
    }, []);

    // ==========================================================================
    // ACCIONES DE PANTALLA Y REGLAS
    // ==========================================================================
    const sendScreen = async (cmd) => { setIsWorking(true); await SendScreenCommandBL(cmd); setIsWorking(false); };
    const forceEnd = async () => { if(window.confirm('¿Terminar partida actual?')) sendScreen('force_end'); };

    const applyRules = async () => {
        setIsWorking(true);
        await SendScreenCommandBL('set_rules', rules);
        alert('Reglas aplicadas a las siguientes partidas.');
        setIsWorking(false);
    };

    // ==========================================================================
    // ACCIONES DE JUGADORES (Reset, Manual, Segunda Oportunidad)
    // ==========================================================================
    const handleResetAll = async () => {
        if (!window.confirm('🚨 ¡PELIGRO! 🚨\n\n¿Estás absolutamente seguro de que quieres BORRAR TODO el historial de jugadores?\nEsto no se puede deshacer.')) return;
        setIsWorking(true);
        await ResetAllScoresBL();
        await loadData();
        setIsWorking(false);
    };

    const handleManualSubmit = async (e) => {
        e.preventDefault();
        setIsWorking(true);
        await SubmitManualScoreBL({ ...manualPlayer, email: 'admin@manual', phoneNumber: '000', companionType: 'manual' });
        setManualPlayer({ fullName: '', nickname: '', score: 0 });
        await loadData();
        setIsWorking(false);
    };

    const giveSecondChance = async (player) => {
        if (!window.confirm(`¿Dar segunda oportunidad a ${player.nickname}? La pantalla empezará su juego al instante.`)) return;
        setIsWorking(true);
        await GiveSecondChanceBL({ 
            fullName: player.fullName, nickname: player.nickname, 
            email: player.email, phoneNumber: player.phoneNumber, companionType: player.companionType 
        });
        setIsWorking(false);
    };

    const toggleCensor = async (p) => { setIsWorking(true); await EditPlayerBL(p.id, p.nickname, !p.isCensored); loadData(); setIsWorking(false); };
    const saveEdit = async (p) => { setIsWorking(true); await EditPlayerBL(p.id, editNickname, p.isCensored); setEditingId(null); loadData(); setIsWorking(false); };

    return (
        <SecondaryBase actionToExecute={async () => { await BLResetCurrentDynamic(); getOutOfTheDynamic(); }}>
            <section className='AdmRunToGoal__Settings'>
                <p className='AdmRunToGoal__Title d-flex justify-content-between align-items-center'>
                    <span>⚽🏆 Atrapa los Balones</span>
                    <span className="badge bg-dark fs-6 shadow-sm">{liveStatus}</span>
                </p>

                <div className='row g-4'>
                    
                    {/* COLUMNA IZQUIERDA: CONTROLES */}
                    <div className="col-lg-4">
                        
                        {/* 1. Control de Pantalla */}
                        <div className="bg-light p-3 rounded border mb-3 shadow-sm">
                            <h6 className="fw-bold border-bottom pb-2">Control de Pantalla</h6>
                            <button className="btn btn-info w-100 mb-2 fw-bold" onClick={() => sendScreen('show_frontpage')} disabled={isWorking}>Mostrar Portada</button>
                            <button className="btn btn-warning w-100 mb-2 fw-bold" onClick={() => sendScreen('show_ranking')} disabled={isWorking}>Mostrar Ranking Top 10</button>
                            <button className="btn btn-danger w-100 fw-bold" onClick={forceEnd} disabled={isWorking}>¡CORTAR PARTIDA ACTUAL!</button>
                        </div>

                        {/* 2. Reglas del Juego */}
                        <div className="bg-light p-3 rounded border mb-3 shadow-sm">
                            <h6 className="fw-bold border-bottom pb-2">Reglas Parametrizables</h6>
                            <label className="small fw-bold">Segundos por partida:</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.duration} onChange={e => setRules({...rules, duration: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Spawn de Balones (Nuevos cada X):</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.ballsToSpawn} onChange={e => setRules({...rules, ballsToSpawn: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Intervalo de Tarjetas (Cada X balones):</label>
                            <input type="number" className="form-control form-control-sm mb-2" value={rules.cardInterval} onChange={e => setRules({...rules, cardInterval: Number(e.target.value)})} />
                            
                            <label className="small fw-bold">Frecuencia de Escudo (Segundos):</label>
                            <input type="number" className="form-control form-control-sm mb-3" value={rules.trophySeconds} onChange={e => setRules({...rules, trophySeconds: Number(e.target.value)})} />

                            <label className="small fw-bold mt-2">Tamaño del Jugador (Escala):</label>
                            <input 
                                type="number" 
                                step="0.1" 
                                className="form-control form-control-sm mb-2" 
                                value={rules.playerScale} 
                                onChange={e => setRules({...rules, playerScale: Number(e.target.value)})} 
                            />
                            
                            <label className="small fw-bold mt-2">Tamaño de Objetos (Escala):</label>
                            <input 
                                type="number" 
                                step="0.1" 
                                className="form-control form-control-sm mb-3" 
                                value={rules.itemScale} 
                                onChange={e => setRules({...rules, itemScale: Number(e.target.value)})} 
                                title="Balones, Escudos y Tarjetas"
                            />
                            
                            <button className="btn btn-dark w-100 btn-sm fw-bold" onClick={applyRules} disabled={isWorking}>Aplicar Reglas</button>
                        </div>

                        {/* 3. Agregar Manual */}
                        <form className="bg-light p-3 rounded border shadow-sm" onSubmit={handleManualSubmit}>
                            <h6 className="fw-bold border-bottom pb-2">Agregar Jugador Manual</h6>
                            <input className="form-control form-control-sm mb-2" placeholder="Nombre Real" value={manualPlayer.fullName} onChange={e => setManualPlayer({...manualPlayer, fullName: e.target.value})} required />
                            <input className="form-control form-control-sm mb-2" placeholder="Apodo (Pantalla)" value={manualPlayer.nickname} onChange={e => setManualPlayer({...manualPlayer, nickname: e.target.value})} required />
                            <input type="number" className="form-control form-control-sm mb-2" placeholder="Puntos Obtenidos" value={manualPlayer.score} onChange={e => setManualPlayer({...manualPlayer, score: Number(e.target.value)})} required />
                            <button type="submit" className="btn btn-success w-100 btn-sm fw-bold" disabled={isWorking}>Guardar Puntaje</button>
                        </form>
                    </div>

                    {/* COLUMNA DERECHA: TABLA Y JUGADORES */}
                    <div className="col-lg-8">
                        <div className="bg-white p-3 rounded border shadow-sm h-100">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                                <h5 className="fw-bold mb-0">
                                    <i className="bi bi-people-fill"></i> Jugadores Registrados: <span className="text-primary">{fullList.length}</span>
                                </h5>
                                <div>
                                    <button className="btn btn-sm btn-outline-dark me-2 fw-bold" onClick={() => setShowFullList(!showFullList)}>
                                        {showFullList ? 'Ver Solo Top 10' : 'Ver Todos'}
                                    </button>
                                    <button className="btn btn-sm btn-danger fw-bold" onClick={handleResetAll} disabled={isWorking}>
                                        <i className="bi bi-trash-fill"></i> Resetear Todo
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-hover align-middle">
                                    <thead className="table-dark sticky-top">
                                        <tr>
                                            <th>Jugador</th>
                                            <th>Apodo</th>
                                            <th className="text-center">Pts</th>
                                            <th className="text-center">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(showFullList ? fullList : ranking).map((p, i) => (
                                            <tr key={p.id} className={p.isCensored ? 'table-danger' : ''}>
                                                <td><div className="fw-bold">{p.fullName}</div></td>
                                                <td>
                                                    {editingId === p.id ? (
                                                        <div className="input-group input-group-sm" style={{ width: '150px' }}>
                                                            <input type="text" className="form-control" value={editNickname} onChange={(e) => setEditNickname(e.target.value)} />
                                                            <button className="btn btn-success" onClick={() => saveEdit(p)}><i className="bi bi-check"></i></button>
                                                        </div>
                                                    ) : (
                                                        <span className={p.isCensored ? 'text-decoration-line-through' : 'fw-bold text-primary'}>{p.nickname}</span>
                                                    )}
                                                </td>
                                                <td className="text-center fw-black fs-5">{p.score}</td>
                                                <td className="text-center">
                                                    <button className="btn btn-sm btn-outline-primary me-1" title="Editar" onClick={() => { setEditingId(p.id); setEditNickname(p.nickname); }}><i className="bi bi-pencil-fill"></i></button>
                                                    <button className={`btn btn-sm me-1 ${p.isCensored ? 'btn-success' : 'btn-danger'}`} title="Censurar" onClick={() => toggleCensor(p)}>
                                                        {p.isCensored ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
                                                    </button>
                                                    {/* BOTÓN SEGUNDA OPORTUNIDAD DESDE EL ADMIN */}
                                                    <button className="btn btn-sm btn-warning fw-bold" title="Forzar Segunda Oportunidad" onClick={() => giveSecondChance(p)}>
                                                        <i className="bi bi-arrow-clockwise"></i> Jugar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </SecondaryBase>
    );
};

export { CatchTheBall };